// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__7AdHM","verifiedBlue":"verified-badge_verifiedBlue__ysU0Z","verifiedGovernment":"verified-badge_verifiedGovernment__NzfXm"};